import { useState } from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { Menu, X, AppWindow, Users, Settings, CreditCard, Building2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button, Sheet, SheetContent, SheetTrigger } from '@/components/ui'

const navItems = [
  { icon: AppWindow, label: 'Apps', href: 'apps' },
  { icon: Users, label: 'Team', href: 'team' },
  { icon: Settings, label: 'Settings', href: 'settings' },
  { icon: CreditCard, label: 'Billing', href: 'billing' },
]

export function MobileNav() {
  const [open, setOpen] = useState(false)
  const { orgSlug } = useParams()
  const baseUrl = orgSlug ? `/orgs/${orgSlug}` : ''

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="fixed bottom-4 right-4 z-50 h-12 w-12 rounded-full bg-[var(--accent)] text-white shadow-lg lg:hidden hover:bg-[var(--accent)]"
        >
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-80 p-0">
        <div className="flex h-full flex-col">
          {/* Header */}
          <div className="flex items-center justify-between border-b border-[var(--border-subtle)] p-4">
            <div className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[var(--accent)]">
                <span className="text-sm font-bold text-white">U</span>
              </div>
              <span className="text-lg font-semibold text-[var(--text-primary)]">
                Console
              </span>
            </div>
            <Button variant="ghost" size="sm" onClick={() => setOpen(false)}>
              <X className="h-5 w-5" />
            </Button>
          </div>

          {/* Org selector */}
          <div className="border-b border-[var(--border-subtle)] p-4">
            <button className="flex w-full items-center gap-3 rounded-lg bg-[var(--bg-elevated)] px-3 py-2 text-left transition-colors hover:bg-[var(--bg-elevated-2)]">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-[var(--accent)] text-white">
                <Building2 className="h-4 w-4" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-[var(--text-primary)]">
                  {orgSlug || 'Select Org'}
                </p>
                <p className="truncate text-xs text-[var(--text-muted)]">
                  Organization
                </p>
              </div>
            </button>
          </div>

          {/* Navigation */}
          <nav className="flex-1 overflow-y-auto p-4">
            <ul className="space-y-1">
              {navItems.map((item) => {
                const Icon = item.icon
                return (
                  <li key={item.href}>
                    <NavLink
                      to={`${baseUrl}/${item.href}`}
                      onClick={() => setOpen(false)}
                      className={({ isActive }) =>
                        cn(
                          'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                          isActive
                            ? 'bg-[var(--accent)]/10 text-[var(--accent)]'
                            : 'text-[var(--text-secondary)] hover:bg-[var(--bg-elevated)] hover:text-[var(--text-primary)]'
                        )
                      }
                    >
                      <Icon className="h-5 w-5" />
                      <span>{item.label}</span>
                    </NavLink>
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </SheetContent>
    </Sheet>
  )
}
